import { render, staticRenderFns } from "./TVSearch.vue?vue&type=template&id=8024f75e&scoped=true&"
import script from "./TVSearch.vue?vue&type=script&lang=js&"
export * from "./TVSearch.vue?vue&type=script&lang=js&"
import style0 from "./TVSearch.vue?vue&type=style&index=0&id=8024f75e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8024f75e",
  null
  
)

export default component.exports